import { Outlet } from "react-router-dom";
import CategoryProvider from "../../Context/CategoryContext/CategoryContext"
import ArticleProvider from "../../Context/ArticleContext/ArticleContext";
import KBProvider from "../../Context/KBContext/KBContext";
import SearchContext from "../../Context/SearchContext/SearchContext";
import AutherProvider from "../../Context/AutherContext/AutherContext";


export const AutherRoutes = () => {
  return (
    <KBProvider>
        <AutherProvider>
            <CategoryProvider>
                <ArticleProvider>
                    <SearchContext>
                        <Outlet />
                    </SearchContext>
                </ArticleProvider>
            </CategoryProvider>
        </AutherProvider>
    </KBProvider>
  );
}